<template>
  <v-dialog v-model="show" max-width="500px" @keydown.enter="addItem">
    <!--<v-btn slot="activator" color="#000000" dark class="add-button mb-2">Lisää tuote</v-btn>-->
    <v-card>
      <v-card-title class="pl-3">
        <span class="headline">Lisää merkkaamo</span>
      </v-card-title>
      <v-container grid-list-md class="pt-0 pb-0 add-product-container">
        <v-row wrap>
          <v-col cols="6" class="py-0 my-0">
            <v-text-field v-model="newItem.name" label="Merkkaamon nimi*" required autofocus></v-text-field>
          </v-col>
          <v-col cols="6" class="py-0 my-0">
            <v-text-field v-model="newItem.webAddress" label="www-osoite"></v-text-field>
          </v-col>
          
          <v-col cols="6" class="py-0 my-0">
            <v-text-field v-model="newItem.address" label="Osoite"></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field v-model="newItem.orderEmail" label="Sähköposti" required></v-text-field>
          </v-col>
          <v-col cols="6" class="py-0 my-0">
            <v-autocomplete
              label="Merkkaustavat"
              :items="settings.printFormats"
              v-model="newItem.printFormats"
              persistent-hint
              item-text="fi"
              item-value="id"
              
              multiple
            />
          </v-col>
          <v-col cols="6" class="py-0 my-0">
            <v-textarea single-line rows=1 :auto-grow="true" v-model="newItem.contacts" label="Yhteyshenkilöt" required></v-textarea>
          </v-col>
          <v-col cols="6" class="py-0 my-0">
            <v-text-field v-model="newItem.username" label="Käyttäjätunnus" required></v-text-field>
          </v-col>        
          <v-col cols="6" class="py-0 my-0">
            <v-text-field v-model="newItem.password" label="Salasana" required></v-text-field>
          </v-col>        
          <v-col cols="12" class="py-0 my-0">
            <v-text-field v-model="newItem.comments" label="Kommentit/Ohjeet" required></v-text-field>
          </v-col>        
          
        </v-row>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="avecor-button-global add-button mb-2" text @click="close">Peruuta</v-btn>
        <v-btn color="avecor-button-global add-button mb-2" text @click="addItem" >Lisää</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapFields,mapMultiRowFields } from 'vuex-map-fields'

export default {
    props:['visible'],
    data: () => ({
      autogrow:true,
      editedIndex: -1,
       newItem: {
        name: '',
        webAddress: '',
        address:'',
        orderEmail: '',
        printFormats:'',
        contacts:'',
        username: '',
        password: '',
        comments:''
      },
      defaultItem: {
        name: '',
        webAddress: '',
        address:'',
        orderEmail: '',
        printFormats:'',
        contacts:'',
        username: '',
        password: '',
        comments:''
      },   
    }),
    mounted() {
    },
    computed: {
      show: {
        get () {
          return this.visible
        },
        set (value) {
          if (!value) {
            this.$emit('close')
          }
        }
      },
      ...mapFields([
        "settings",
      ])
    },
    created () {},
    methods: {
      customFormatter(date) {
        var da = dateFormat(date, "yyyy-mm-dd")
        return da
      },
      close () {
        this.show = false
        setTimeout(() => {
          this.newItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      async addItem () {
        if(this.newItem.name === '') {alert("Täytä *-kentät"); return}
        
        console.log(this.newItem)
        let {id, ...y} = this.newItem;
        const newId = await this.$store.dispatch('printShop/set', {
          id,
          ...y
        })
        this.close()
      },
      inlineCancel () {
      },
      inlineOpen () {
      },
      inlineClose () {
        //console.log('Dialog closed')
      }
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/blocks/AddPrintShop.vue